<template>
    <div>
        <div v-if="searchUrlInsPosts != null && isInstagram && profileData !== null">
            <div class="user-profile">
                <div class="user-profile__avatar">
                    <img :src="this.profileData.profilePicture" alt="user-avatar" class="avatar" @error="handleLoadErrorImage()" ref="avatarImageRef">
                    <a v-if="this.profileData.downloadableAvatarUrl" :href="profileData.downloadableAvatarUrl" download="true">
                        <img src="/img/icons/download.svg" class="avatar-dl-icon">
                    </a>
                </div>
                <div class="user-profile__content profile">
                    <div class="profile__nickname">{{ this.profileData.username ? `@${this.profileData.username}` : '' }}</div>
                    <div class="profile__stats">
                        <div class="stats-item">
                            <div class="stats-item__value">{{ formatNumber(this.profileData.edge_owner_to_timeline_media.count) }}</div>
                            <div class="stats-item__label">Posts</div>
                        </div>
                        <div class="stats-item">
                            <div class="stats-item__value">{{ formatNumber(this.profileData.edge_follow.count) }}</div>
                            <div class="stats-item__label">Followers</div>
                        </div>
                        <div class="stats-item">
                            <div class="stats-item__value">{{ formatNumber(this.profileData.edge_followed_by.count) }}</div>
                            <div class="stats-item__label">Following</div>
                        </div>
                    </div>
                    <div class="profile__description">{{ this.profileData.full_name }}</div>
                </div>
            </div>
            <div class="switch-container" v-if="this.profileData">
                <button v-bind:class="['switch-btn', activBtn === 'posts' ? 'switch-btn--active' : null]"
                        @click="activePage('posts')"> Posts </button>
                <button v-bind:class="['switch-btn', activBtn === 'stories' ? 'switch-btn--active' : null]"
                        @click="activePage('stories')"> Stories </button>
                <button v-bind:class="['switch-btn', activBtn === 'highlights' ? 'switch-btn--active' : null]"
                        @click="activePage('highlights')"> Highlights </button>
                <button v-bind:class="['switch-btn', activBtn === 'reels' ? 'switch-btn--active' : null]"
                        @click="activePage('reels')"> Reels </button>

            </div>
            <highlights-component
                            v-if="activBtn == 'highlights'"
                            :highlights="highlights"
                            :abort-controller="abortController"
                            @highlightClick="handleHightlightClick"
                            @dropHighlight="dropHighlight"
                            @startLoading="startLoading"
                            @endLoading="endLoading"
                >
            </highlights-component>
            <main-results v-if="activBtn == 'posts' && searchUrlInsPosts !== null" :activ-btn="activBtn"
                          :search-url-ins-posts="searchUrlInsPosts" :key="'posts'"
                          @startLoading="startLoading" @endLoading="endLoading">
            </main-results>
            <main-results v-if="activBtn == 'stories'"
                          :activ-btn="activBtn"
                          :stories="stories" :key="'stories'"
                          @loadStories="loadStories"
                          @startLoading="startLoading" @endLoading="endLoading">
            </main-results>

            <main-results v-if="activBtn == 'highlights' && highlightStories" :activ-btn="activBtn"
                           :key="'highlights'" :highlight-stories="highlightStories"
                           @startLoading="startLoading"
                            @endLoading="endLoading">

            </main-results>
            <main-results v-if="activBtn == 'reels' && searchUrlInsReels !== null" :activ-btn="activBtn"
                          :search-url-ins-reels="searchUrlInsReels" :key="'reels'"
                          @startLoading="startLoading" @endLoading="endLoading">
            </main-results>

        </div>
        <div v-if="error">
            <ErrorBlock :error="error" />
        </div>

        <loader-component v-if="isLoading" :is-loading="isLoading"></loader-component>

        <div class="norton">
            <p>Scanned by</p>
            <img loading="lazy" src="/img/norton.svg" alt=''>
            <p>Norton<sup>TM</sup> Safe Web</p>
        </div>
    </div>
</template>

<script>
import LoaderComponent from "./LoaderComponent.vue";
import ErrorBlock from "./ErrorBlock";
import HighlightsComponent from "./HighlightsComponent";
import MainResults from './MainResults.vue'; // posts //stories
import formatNumber from "../tools/formatNumber";
import mediaUrlProcessor from '../tools/MediaUrlProcessor'
import noAvatarImagePicture from "../../img/placeholder/no-avatar.png";
import adaptStories from "../tools/adaptStories";
import { isProfileLink, isInstagramContext } from '../tools/instagramLinks';
import { IgApi } from "../api/instagram";

export default {
    components: {
        ErrorBlock,
        MainResults,
        HighlightsComponent,
        LoaderComponent,
    },
    data() {
        return {
            error: null,
            activBtn: null,
            isInstagram: null,
            searchUrlInsPosts: null,
            searchUrlInsReels: null,
            stories: null,
            highlights: null,
            highlightStories: null,
            input: null,
            urlAddress: -1,
            profileData: null,
            abortController: new AbortController(),
            isLoading: false
        }
    },
    mounted() {
        this.$root.$on('clear-results', () => {
            this.error = null;
            this.highlights = null;
            this.highlightStories = null,
            this.stories = null;
            this.profileData = null;
        });
        this.$root.$on('search-request', (string) => {
            this.highlights = null;
            this.highlightStories = null,
            this.stories = null;
            this.profileData = null;
            if (string === null) {
                this.searchUrlInsPosts = null;
                this.searchUrlInsReels = null;
                this.input = null;
            } else {
                this.searchRequest(string)
            }
        });
        this.$root.$on('link-insert', (link) => {
            this.searchRequest(link)
        })
        this.$root.$on('handleError', (response, message) => {
            this.handleError(response, message)
        })
    },
    methods: {
        handleError(result, message = null) {
            this.$root.$emit('show-error', result, this.link);
            this.error = message ? { message } : true;
        },
searchRequest(string) {
        // Тот же предикат, что в SearchForm.handleSubmit: иначе профильные ссылки,
        // которые матчит только isProfileLink (instagr.am/username), молча не обрабатываются.
        this.isInstagram = isInstagramContext(string) || isProfileLink(string)

        this.urlAddress = string.search(/^http|^https:\/\/|^www\.|^instagram\.com|instagr\.am/gi)

        if (this.isInstagram) {
            if (string[0] === "@") {
                this.input = string.substring(1)
            } else if (isProfileLink(string)) {
                string = string.trim().match(/[\d\w-_.]+\/?$/gims)[0];
                if (string[string.length - 1] === '/') {
                    string = string.substring(0, string.length - 1)
                }
                this.input = string;
            } else {
                this.input = string;
            }
            this.loadUserData()
            this.activePage()
        }
    },
        async loadProfile() {
            if(this.abortController){
                this.abortController.abort()
                this.abortController = new AbortController()
            }
            this.startLoading()
            const input = this.input.trim()
            return IgApi.getProfile({
                username: input,
                signal: this.abortController.signal,
                subscribeSignedRequestBody: this.$root.subscribeSignedRequestBody,
            }).then((response) => {
                this.profileData = response.data.result;
                this.profileData.profilePicture = response.data.result.profile_pic_url_wrapped || mediaUrlProcessor.getPreviewUrl(
                    response.data.result.profile_pic_url,
                    response.data.result.profile_pic_url_signature
                )
                this.profileData.downloadableAvatarUrl = response.data.result.profile_pic_url_downloadable || mediaUrlProcessor.getDownloadableUrl(
                    response.data.result.profile_pic_url,
                    response.data.result.profile_pic_url_signature
                );
                return this.profileData
            }).catch((error) => {
                if(error.response && error.response.status === 404){
                    this.error = { message: "User not found" }
                } else {
                    this.error = true
                }
            })
            .finally(() => {
                this.endLoading()
            })
        },
        async loadHighlights(profileId) {
            if(this.abortController){
                this.abortController.abort()
                this.abortController = new AbortController()
            }
            this.startLoading()
            return IgApi.getHighlights({
                profileId,
                signal: this.abortController.signal,
                subscribeSignedRequestBody: this.$root.subscribeSignedRequestBody,
            }).then((response) => {
                this.highlights = response.data.result.map(highlight => {
                    const preview = highlight.cover_media.cropped_image_version.url_wrapped || mediaUrlProcessor.getPreviewUrl(highlight.cover_media.cropped_image_version.url,
                    highlight.cover_media.cropped_image_version.url_signature);

                    return {
                        preview,
                        id: highlight.id,
                        title: highlight.title
                    }
                })
                return this.highlights
            })
                .catch((error) => {
                    this.error = true
                })
                .finally(() => this.endLoading())
        },
        async loadStories() {
            if(this.abortController){
                this.abortController.abort()
                this.abortController = new AbortController()
            }
            this.startLoading()
            return IgApi.getStories({
                userId: this.profileData.id,
                username: this.profileData.username,
                signal: this.abortController.signal,
                subscribeSignedRequestBody: this.$root.subscribeSignedRequestBody,
            }).then((response) => {
                if(!response.data.result){
                    this.stories = []
                    return []
                }
                const result = adaptStories(response.data.result)

                this.stories = result
                return result
            })
                .catch((error) => {
                    this.error = true
                })
                .finally(() => this.endLoading())
        },
        async loadUserData(){
            return this.loadProfile().then((profile) => {
                this.loadHighlights(profile.id)
            })
        },
        formatNumber(number) {
            return formatNumber(number);
        },
        handleHightlightClick(
            highlightStories,
            abortController
        ) {
            this.highlightStories = highlightStories;
            this.abortController = abortController;
            this.endLoading()

        },
        dropHighlight(){
            this.highlightStories = null
        },
        startLoading() {
            this.isLoading = true
        },
        endLoading() {
            this.isLoading = false
        },
        activePage(page = 'posts') {
            if(this.activBtn !== page && !!this.activeBtn){
                this.abortController.abort()
                this.abortController = new AbortController()
            }
            this.activBtn = page;
            this.error = null
            if (this.input) {
                this.searchUrlInsPosts = `https://www.instagram.com/${this.input}/`;
                this.searchUrlInsReels = `https://www.instagram.com/${this.input}/reels/`;
            }
        },
        handleLoadErrorImage() {
            this.$refs.avatarImageRef.src = noAvatarImagePicture;
        },
    }
}
</script>
../tools/instagramLinks
